<template>
  <div class="container">
    <div class="bar" ref="bar" :class="{'is-fixed': isOutOfPort}">
      <div class="bar-item"
      :class="[index === activeIndex ? 'is-active' : '', `bar-item-${index}`]"
      v-for="(item ,index) in branchList" :key="index"
      @click="barHandler(index)">
        {{ item.name  }}
      </div>
    </div>
  </div>
</template>

<script>
import VueBus from '@/util/vueBus'

export default {
  data () {
    return {
      activeIndex: 0,
      isOutOfPort: false,
      itemScrollTopInfo: []
      // isOpen: false
    }
  },
  props: ['branchList'],
  created () {
  },
  mounted () {
    VueBus.$on('setTargetIndex', index => {
      this.activeIndex = index

      document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    })

    if (this.$refs.bar && this.$refs.bar.getBoundingClientRect().left < 0) this.isOutOfPort = true
  },
  methods: {
    /**
     * 滚动到对应的 分会
     * @param {index} Number 对应 bar 的 索引值
     */
    barHandler (index) {
      this.activeIndex = index

      VueBus.$emit('scrollToTargetBranch', index)

      document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },
    mouseOverHandler ($event) {
      console.log($event)
    }
  },
  watch: {
    'branchList': {
      handler: function () {
        this.$nextTick(() => {
          // 父元素的高度
          let barEle = document.querySelector('.bar')
          let barHeight = barEle.offsetHeight
          // 每个 item 的高度
          document.querySelectorAll('.bar-item').forEach(ele => {
            this.itemScrollTopInfo.push(ele.offsetTop + ele.offsetHeight / 2 - barHeight / 2)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.container {
  width: 90px;
  position: fixed; left: 10px; top: 25vh;
  transition: all 0.3s linear;
  z-index: 100;
  box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
  &.is-open {
    left: 10px;
  }
  @media screen and (min-width: 1480px) {
    left: 50%;
    transform: translateX(calc(-610px - 100%))
  }
}
.bar {
  max-height: 50vh;
  overflow-y: scroll;
  z-index: 999;
  background:#F8F8F8;
  border-radius:3px;
  cursor: pointer;
  transition: all 0.3s linear;
  scroll-behavior: smooth;

  // 去掉滚动条 start
  scrollbar-width: none;
   -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  // 去掉滚动条 end

  .bar-item {
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(74,74,74,1);
    line-height: 2.5;
    text-align: center;
    padding: 2px 0;
    // margin: 6px 0;
  }

  .is-active {
    background: rgba(215,179,117,0.1);
    color: #D7B375;
    font-weight: 500;
  }

}
</style>
